export default __webpack_public_path__ + "static/Living-in-STL_2-07a06f5ab368cfd4c1dd93d80deb1a08.jpg";